import React, { FC } from "react";
import Select from "react-select";
import SelectStyles from "./SelectStyles";
import Button from "../../_Atoms/Buttons/Button/Button";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";

interface IProps {
  options: SelectOption[];
  selected: string | true | SelectOption | SelectOption[];
  onChange: (item: SelectOption) => void;
  label?: string;
  placeholder?: string;
  isDisabled?: boolean;
  id?: string;
  className?: string;
  multi?: boolean;
  containerStyles?: React.CSSProperties;
  handleClearSelectedFilter?: (id: string) => void;
}

const FormSelect: FC<IProps> = ({
  options,
  selected,
  onChange,
  label,
  placeholder,
  isDisabled,
  id,
  className,
  multi,
  containerStyles,
  handleClearSelectedFilter
}) => {
  return (
    <div className="form-select" data-tid={id} id={id} style={containerStyles}>
      <label className="select-label">{label}</label>
      <Select
        options={options}
        onChange={onChange}
        className={className}
        name="categoryOptions"
        placeholder={placeholder || label}
        styles={SelectStyles}
        menuPosition={"fixed"}
        value={selected || ""}
        instanceId={id}
        isSearchable
        label={label}
        isDisabled={isDisabled}
        id={id}
        isMulti={multi}
        isClearable={false}
      />
      {handleClearSelectedFilter && selected && !multi && (
        <Icon
          color="black"
          icon="trash"
          onClick={() => handleClearSelectedFilter(id)}
          style={{ position: "absolute", right: 40, top: 35, cursor: "pointer" }}
        />
      )}
    </div>
  );
};

export default FormSelect;
